const config = {
  backendBaseUrl: process.env.REACT_APP_BACKEND_URL,
  extensionDownloadUrl: process.env.REACT_APP_EXTENSION_DOWNLOAD_URL,  
  googleAiStudioUrl: process.env.REACT_APP_GOOGLE_AI_STUDIO_URL,
  extensionVersion: process.env.REACT_APP_EXTENSION_VERSION,
  accessTokenKey: 'neopass_access_token',
  refreshTokenKey: 'neopass_refresh_token',
  
  // Video URLs
  videos: {
    installation: process.env.REACT_APP_VIDEO_INSTALLATION,
    guideMcq: process.env.REACT_APP_VIDEO_GUIDE_MCQ,
    guideCoding: process.env.REACT_APP_VIDEO_GUIDE_CODING,
    buyCredits: process.env.REACT_APP_VIDEO_BUY,
  },
  
  razorpayKeyId: process.env.REACT_APP_RAZORPAY_KEY_ID,
  
  tokenRefreshThreshold: 60 * 1000,
  
  shortcuts: [
    { keys: ['Alt', 'Shift', 'Q'], action: 'Solve all MCQs' },
    { keys: ['Alt', 'Shift', 'T'], action: 'Type Code (Human-like)' },
    { keys: ['Alt', 'Shift', 'A'], action: 'AI Solve (MCQ/Coding)' },
    { keys: ['Alt', 'Shift', 'V'], action: 'Custom Paste (Bypass)' },
    { keys: ['Esc'], action: 'Stop/Close Assistant' },
  ],
};

export default config;
